// @flow

import Resource from 'speed-js-core/src/api/Resource';
import type { UUID } from 'esm-web-pro/types/common';

export default class ContinuousPipeResource extends Resource {
    basePath: string = 'networks/continuous-pipes/';

    objectPath: string = 'networks/continuous-pipes/{ident}/';

    path(id: string, params: Object): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}path/`,
            'GET',
            params,
        ).then((response) => response.data);
    }

    connect(id: UUID, data: { pipe: UUID, point: UUID }): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}connect/`,
            'POST',
            data,
        ).then((response) => response.data);
    }

    split(id: UUID, data: { point: UUID }): Promise<Object> {
        return this.client._request(
            // $FlowFixMe
            `${this._getObjectPath(id)}split/`,
            'POST',
            data,
        ).then((response) => response.data);
    }
}
